module.exports = "/static/assets/e63cba8e439578f337a8165515cbb43f.png";